export default __webpack_public_path__ + "static/media/Searchn.dea0bac5.svg";